import React from "react";
import { FaMicrophone } from "react-icons/fa";
import useIsDemo from "../hooks/useIsDemo";

const FloatingActionButton = ({ onClick, title = "Contanos tu problema" }) => {
  const { isDemo } = useIsDemo();
  // Modo demo: ocultamos el FAB. Es la accion que dispara crear incidencia,
  // que en demo esta deshabilitada (read-only).
  if (isDemo) return null;

  return (
    <div
      style={{
        position: "fixed",
        bottom: 24,
        right: 24,
        zIndex: 1000,
      }}
    >
      <button
        onClick={onClick}
        style={{
          width: 56,
          height: 56,
          borderRadius: "50%",
          backgroundColor: "#0080ff",
          color: "white",
          fontSize: 22,
          border: "none",
          boxShadow: "0 4px 16px rgba(0, 128, 255, 0.4)",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          transition: "all 0.2s ease",
        }}
        aria-label={title}
        title={title}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = "#0066cc";
          e.currentTarget.style.transform = "scale(1.05)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = "#0080ff";
          e.currentTarget.style.transform = "scale(1)";
        }}
      >
        <FaMicrophone />
      </button>
    </div>
  );
};

export default FloatingActionButton;